export const isFlourish = (link: string) => {
    return link.indexOf('https://public.flourish.studio/') >= 0
}
export function flourishDataSrcFromUrl(link: string) {
    const flourishDataSrc =
        link.replace('https://public.flourish.studio/', '').slice(0, -1) + ''

    return flourishDataSrc
}
